import customerInstance from '../instance'

const storeDeliveryConfig = (data) => {
  return customerInstance.post('/delivery-configs', data)
}

export default storeDeliveryConfig
